'use strict';

var dialog = require('../../dialog'),
    minicart = require('../../minicart'),
    page = require('../../page'),
    util = require('../../util'),
    Promise = require('promise'),
    ajax = require('../../ajax'),
    cartOverlay = require('./cartOverlay'),
    validator = require('../../validator'),
    _ = require('lodash');

/**
 * @description Make the AJAX request to add an item to cart
 * @param {Element} form The form element that contains the item quantity and ID data
 * @returns {Promise}
 */
var addItemToCart = function (form) {
	var prodPrice;
	if ($('#pdpMain').find('.input-fields-set input:visible').length > 0) {
		var monotxt;
		$('#pdpMain').find('.input-fields-set input').each(function() {
			if (monotxt != null) {
				monotxt = monotxt +'~-'+ $(this).val();
			} else {
				monotxt = $(this).val();
			}
		});
		$('input[name="monogrammingText"]').val(monotxt);
	}

	var $form = $(form),
    	 $qty = $form.find('input[name="Quantity"]');
    if ($qty.length === 0 || isNaN($qty.val()) || parseInt($qty.val(), 10) === 0) {
        $qty.val('1');
    }
    if( $form.find('.price-sales').length > 0 ){
		prodPrice = $form.find('.price-sales').text().replace(/\$/g, '').trim();
	}else if( $form.find('.price-standard').length > 0){
		prodPrice = $form.find('.price-standard').text().replace(/\$/g, '').trim()
	}

	if( $form.find('.quick-order-price').length > 0 ){
		prodPrice = $form.find('.quick-order-price').text().replace(/\$/g, '').trim();
	}

	$form.find('input[name="priceVal"]').val(prodPrice);

	// if(typeof (MERCH_UTILS) !== 'undefined') {
	// 	MERCH_UTILS.setProductAddToCartCookie("_productAddToCartMethod", $form.find('#mpid').val(), MERCH_UTILS.getCookie('_productFindingMethodOSS'));
	// }

    return Promise.resolve($.ajax({
        type: 'POST',
        url: util.ajaxUrl(Urls.addProduct),
        async: false,
        data: $form.serialize()
    })).then(function (response) {
        // handle error in the response
        if (response.error) {
            throw new Error(response.error);
        } else {
            return response;
        }
    });
};
/**
 * @description Handler to handle the add to cart event
 */
var validateMonogramming = function ($this) {
	var validationStatus='success';
	var $hemmingmonograming = $($this).closest('.hemmingmonograming');
	var $monogrammingCheckBox = $hemmingmonograming.find('.monogramming-enabled-class');
	if($monogrammingCheckBox.prop('checked')){
    	if($hemmingmonograming.find('.monogram-font-class :selected').val()==='' && !($hemmingmonograming.find('.monogramming-font').hasClass('custom-select-hide'))){
    		$hemmingmonograming.find('.monogram-font-class :selected').text('').text(Resources.INVALID_FONT);
    		$hemmingmonograming.find('.custom-select.monogram-font-class').find('.selected-option.selected').text('').text(Resources.INVALID_FONT);
    		$hemmingmonograming.find('.monogram-font-class').addClass('mono-error');
    		$hemmingmonograming.find('.monogram-font-class').closest('.product-monogramming').addClass('error-msg');
    		validationStatus='failed';
    	}
    	if($hemmingmonograming.find('.monogram-location-class :selected').val()==='' && !($hemmingmonograming.find('.monogramming-location').hasClass('custom-select-hide'))){
    		$hemmingmonograming.find('.monogram-location-class :selected').text('').text(Resources.INVALID_POSITION);
    		$hemmingmonograming.find('.custom-select.monogram-location-class').find('.selected-option.selected').text('').text(Resources.INVALID_POSITION);
    		$hemmingmonograming.find('.monogram-location-class').addClass('mono-error');
    		$hemmingmonograming.find('.monogram-font-class').closest('.product-monogramming').addClass('error-msg');
    		validationStatus='failed';
    	}
    	if($hemmingmonograming.find('.monogram-color-class :selected').val()==='' && !($hemmingmonograming.find('.monogramming-color').hasClass('custom-select-hide'))){
    		$hemmingmonograming.find('.monogram-color-class :selected').text('').text(Resources.INVALID_COLOR);
    		$hemmingmonograming.find('.custom-select.monogram-color-class').find('.selected-option.selected').text('').text(Resources.INVALID_COLOR);
    		$hemmingmonograming.find('.monogram-color-class').addClass('mono-error');
    		$hemmingmonograming.find('.monogram-font-class').closest('.product-monogramming').addClass('error-msg');
    		validationStatus='failed';
    	}
    	$hemmingmonograming.find('.monogramming-textfield').each(function(index,value){
    		if($(this).val()===''){
    			$(this).attr('placeholder',Resources.INVALID_TEXT).addClass('mono-error');
    			$hemmingmonograming.find('.monogram-font-class').closest('.product-monogramming').addClass('error-msg');
        		validationStatus='failed';
    		}
    	});
	}
	return validationStatus;
}

/**
 * @description Handler to handle the add to cart event
 */
var addToCart = function (e) {
	if(($('.add-to-cart').length && $('.add-to-cart').attr('aria-disabled') === "true") || ($('#mm-add-to-cart').length && $('#mm-add-to-cart').attr('aria-disabled') === "true")){
		return false;
	}
	
    e.preventDefault();
	validator.init();
	// WCAG mini bag flyout class added on tab
	$('.shopping-bag-sm').addClass('flyout-cart');
    var specialproduct = $(this).parents('.mm-prod-details');
    if(specialproduct != null && specialproduct.find('.disablemessage').length > 0) {
		$(this).prev('.disablemessage').show();
		//adding error class to mixmatch dropdown
		if ($('.pt_specials').length ==1 && $(this).closest('.mm-prod-details').find('.unselected').length > 0) {
			var unselected = $(this).closest('.mm-prod-details').find('.unselected').val();
			if (unselected != undefined && unselected != null && unselected != '') {
				$(this).closest('.mm-prod-details').find(unselected).addClass('error');
			}
		}
		return false;
	}
    var personalizedValues = [];
    var giftEmailValues = [];
    var attributes='';
    var giftAmountValue='';
    var giftAmount = $('.product-col-2').find('.product-variations .selected-option').text();
    if(giftAmount == 'Select Amount'){
    	giftAmountValue = giftAmount.split('Select')[1];
    }
    $('.product-col-2').find('.form-row .input-text.required').each(function(index,value){
    	var placeHolderName = $(this).attr('placeholder');
    	if(placeHolderName == undefined) {
            placeHolderName = $(this).data('required-text');
    	}
    	if(placeHolderName != "To"){
    		var placeHolderValue = $(this).val();
        	if(placeHolderValue==""){
        		if(giftEmailValues.indexOf(placeHolderName) == -1){
        			giftEmailValues.push(placeHolderName);
        		}
    		}
    	}
    	
	});
    $('.product-add-to-cart').find('.fields-address .form-row input').each(function(index,value){
		var placeHolderName = $(this).attr('placeholder');
		if(placeHolderName == undefined) {
            placeHolderName = $(this).data('required-text');
    	}
		var placeHolderValue = $(this).val();
		if(placeHolderValue==""){
			if(personalizedValues.indexOf(placeHolderName) == -1){
				personalizedValues.push(placeHolderName);
			}
			
		}
	});

	var attributes='';
	//e-gift card form input fields
	var purchaseMessage = $('textarea[name$="_purchase_message"]'),
		purchaseEmail = $('input[name$="_purchase_email"]'),
		purchaseConfirmEmail = $('input[name$="_purchase_confirmemail"]'),
		purchaseFrom =  $('input[name$="_purchase_from"]'),
		purchaseRecipient = $('input[name$="_purchase_recipient"]'),
		personalizedMessageChecked = $('input[name$="_personalizedMessage"]:checked');
	



	if(personalizedMessageChecked.length>0){
		for (var i = 0; i < giftEmailValues.length; i++) {
			if(i == 0)
				attributes += '  ' + giftEmailValues[i] + ' ';			
			else
				attributes += ' , ' + giftEmailValues[i] + ' ';			
		}
		for(var j = 0; j < personalizedValues.length; j++){
			if(attributes=='')
				attributes +='  ' + personalizedValues[j];
			else
				attributes += ' , ' + personalizedValues[j];	
		}
	}else{
		for (var i = 0; i < giftEmailValues.length; i++) {
			if(i == 0)
				attributes += '  ' + giftEmailValues[i] + ' ';			
			else
				attributes += ' , ' + giftEmailValues[i] + ' ';			
		}
	}

	// error message label
	var errorPleaseSelectLabel = $('.please-select');
	// reset value to nothing on each click
	errorPleaseSelectLabel.html('');

    if(giftAmountValue != '' && $('.mm-content').length <= 0) {
		if(personalizedMessageChecked.length>0){
			$(this).closest('#product-content').find('.product-variations.gift-card select').addClass('error');
			
			if(purchaseFrom.val() == ''){
				purchaseFrom.closest('.form-row').addClass('error');
			}
			if(purchaseRecipient.val() == ''){
				purchaseRecipient.closest('.form-row').addClass('error');
			}
			if(purchaseMessage.val() == ''){
				purchaseMessage.closest('.form-row').addClass('error');
			}
			if(purchaseEmail.val() == ''){
				purchaseEmail.closest('.form-row').addClass('error');
			}
			if(purchaseConfirmEmail.val() == ''){
				purchaseConfirmEmail.closest('.form-row').addClass('error');
			}
			if(attributes != '' && purchaseMessage.val() == ''){
				errorPleaseSelectLabel.html(Resources.GIFTCARD_PLEASE + ' ' + Resources.GIFTCARD_SELECT + giftAmountValue +',' + attributes + ' and ' +purchaseMessage.closest('.form-row').find('span').html()).addClass('error');
			}else if(attributes == '' && purchaseMessage.val() == '') {
				errorPleaseSelectLabel.html(Resources.GIFTCARD_PLEASE + ' ' + Resources.GIFTCARD_SELECT + giftAmountValue + ' and ' +purchaseMessage.closest('.form-row').find('span').html()  ).addClass('error');
			}else if(attributes != '' && purchaseMessage.val() != '') {
				errorPleaseSelectLabel.html(Resources.GIFTCARD_PLEASE + ' ' + Resources.GIFTCARD_SELECT + giftAmountValue +',' + attributes  ).addClass('error');
			}else{
				errorPleaseSelectLabel.html(Resources.GIFTCARD_PLEASE + ' ' + Resources.GIFTCARD_SELECT + giftAmountValue ).addClass('error');
			}
    		return false;
		}else{
    		$(this).closest('#product-content').find('.product-variations.gift-card select').addClass('error');
    		var fieldValue1= false;
    		var fieldValue2= false;
    		if(purchaseEmail.val() !='' && purchaseConfirmEmail.val() !=''){
    			errorPleaseSelectLabel.html(Resources.GIFTCARD_PLEASE + ' ' + Resources.GIFTCARD_SELECT + giftAmountValue).addClass('error');
    			return false;
    		}
    		if(purchaseEmail.val() == ''){
    			purchaseEmail.closest('.form-row').addClass('error');
    			fieldValue1= true;
    		}
    		if(purchaseConfirmEmail.val() == ''){
    			purchaseConfirmEmail.closest('.form-row').addClass('error');
    			fieldValue2= true;
    		}
    		if(fieldValue1 || fieldValue2){
    			errorPleaseSelectLabel.html(Resources.GIFTCARD_PLEASE + ' ' + Resources.GIFTCARD_SELECT + giftAmountValue +',' + attributes  ).addClass('error');
			}
			return false;
		}
    }else if(personalizedMessageChecked.length>0)	{
		var isValid = true;		
		if(purchaseEmail.val() == ''){
			purchaseEmail.closest('.form-row').addClass('error');
		}
		if(purchaseConfirmEmail.val() == ''){
			purchaseConfirmEmail.closest('.form-row').addClass('error');
		}	
		if(purchaseRecipient.val() == "" || purchaseFrom.val() == "" || purchaseMessage.val() == ""){
			if(purchaseMessage.val() == '' && purchaseRecipient.val()!="" &&  purchaseFrom.val()!=""){
				$(this).closest('form').find('input').addClass('error');
				if(attributes != ''){
					errorPleaseSelectLabel.html(Resources.GIFTCARD_PLEASE + ' ' + Resources.GIFTCARD_ADD + attributes + ' and ' + purchaseMessage.closest('.form-row').find('span').html()).addClass('error');
				}else{
					errorPleaseSelectLabel.html(Resources.GIFTCARD_PLEASE + ' ' + Resources.GIFTCARD_ADD + ' ' +purchaseMessage.closest('.form-row').find('span').html()).addClass('error');
				}
				purchaseMessage.closest('.form-row').addClass('error');
				isValid = false;
			}else if(purchaseMessage.val() != "" && (purchaseFrom.val() == "" || purchaseRecipient.val() == "")){
				$(this).closest('form').find('input').addClass('error');
				if (purchaseRecipient.val() == "") {
					purchaseRecipient.closest('.form-row').addClass('error');
				}
				if (purchaseFrom.val() == "") {
					purchaseFrom.closest('.form-row').addClass('error');
				}
				errorPleaseSelectLabel.html(Resources.GIFTCARD_PLEASE + ' ' + Resources.GIFTCARD_ADD + attributes).addClass('error');
				isValid = false;
			}else if(purchaseMessage.val() == "" && (purchaseFrom.val() != "" || purchaseRecipient.val() != "")){
				$(this).closest('form').find('input').addClass('error');
				purchaseMessage.closest('.form-row').addClass('error');
				if (purchaseRecipient.val() == "") {
					purchaseRecipient.closest('.form-row').addClass('error');
				}
				if (purchaseFrom.val() == "") {
					purchaseFrom.closest('.form-row').addClass('error');
				}
				errorPleaseSelectLabel.html(Resources.GIFTCARD_PLEASE + ' ' + Resources.GIFTCARD_ADD + attributes+ ' and ' + purchaseMessage.closest('.form-row').find('span').html()).addClass('error');
				isValid = false;
			}else {
				$(this).closest('form').find('input').addClass('error');
				errorPleaseSelectLabel.html(Resources.GIFTCARD_PLEASE + ' ' + Resources.GIFTCARD_ADD + attributes + ' and ' + purchaseMessage.closest('.form-row').find('span').html()).addClass('error');
				purchaseRecipient.closest('.form-row').addClass('error');
				purchaseFrom.closest('.form-row').addClass('error');
				purchaseMessage.closest('.form-row').addClass('error');
				isValid = false;
			}			
		}else if(purchaseEmail.val() == '' || purchaseConfirmEmail.val() == ''){
			errorPleaseSelectLabel.html(Resources.GIFTCARD_PLEASE + ' ' + Resources.GIFTCARD_ADD + attributes).addClass('error');
			if(purchaseEmail.val() == ''){
				purchaseEmail.closest('.form-row').addClass('error');
			}
			if(purchaseConfirmEmail.val() == ''){
				purchaseConfirmEmail.closest('.form-row').addClass('error');
			}
			isValid = false;
		}
		
		
		if(!isValid)
			return false;
	}else{
		if(purchaseEmail.val() == '' || purchaseConfirmEmail.val() == ''){
			errorPleaseSelectLabel.html(Resources.GIFTCARD_PLEASE + ' ' + Resources.GIFTCARD_ADD + attributes).addClass('error');
			if(purchaseEmail.val() == ''){
				purchaseEmail.closest('.form-row').addClass('error');
			}
			if(purchaseConfirmEmail.val() == ''){
				purchaseConfirmEmail.closest('.form-row').addClass('error');
			}
			return false;
		}
	}
    var errorMsg="";
    $(this).closest('.product-set-item').find('.product-variations div.attribute_label').each(function(index,val){
    	if($(this).find('.selected-value').length ==0 && $(this).find('.label').text().length > 0){
    		if(errorMsg==""){
    			errorMsg="Please Select "+$(this).find('.label').text().split(":")[0];
    		}else{
    			errorMsg= errorMsg+' , '+$(this).find('.label').text().split(":")[0];
    		}
    	}
    });
    if(errorMsg!=""){
    	$(".color-not-selected").html(errorMsg);
    	$(".color-not-selected").removeClass("hide-error").addClass("show-error padding-eight");
		return false;
    }else{
    	$(".color-not-selected").removeClass("show-error padding-eight").addClass("hide-error");
    }
	if(validateMonogramming(this) === 'failed'){
    	return false;
	}
    var $form = $(this).closest('form');
    if(!$(this).closest('form').valid()){
		return false;
	}
    var isValidHemming = validateHemming($(this));
    if (!isValidHemming) {
    	return false;
    }
    checkCartAvailbility($form);
};



var checkCartAvailbility = function ($form) {
	var Qty = 1;
	if($('.product-detail').length > 0) {
		Qty = $('.product-detail').find('Select[name="Quantity"]').val();
	} else if($('.wishlist-main').length > 0) {
		Qty = $form.closest('.item-dashboard').find('Select[name="Quantity"]').val();
	} else if($('.special-result-content').length > 0){
		Qty = 1;
	} else {
		Qty = $form.find('.product-quickorder-detail').find('Select[name="Quantity"]').val();
	}
	var dataForAjax;
	dataForAjax = {'pdtQty' : Qty};
	var serialForm = $form.serialize();
	if(serialForm.indexOf("cartAction=update") > -1 && serialForm.indexOf("source=wishlist") > -1) {
		checkProductATS($form);
	} else {
		if(serialForm.indexOf("cartAction=update") > -1) {
			dataForAjax = serialForm;
		}
		ajax.getJson({
	        url: util.ajaxUrl(Urls.getCartAvailability),
	        data: dataForAjax,
	        callback: function (response) {
	        	var cartQty = response.error;
	        	var flag = true;
	        	if($('.wishlist-main').length > 0) {
	        		if(cartQty > 40) {
	        			$('.max-cart-qty').hide();
	        			$form.closest('.wishlist-row').find('.max-cart-qty').show();
	            		flag = false;
	            	} else {
	            		$form.closest('.wishlist-row').find('.max-cart-qty').hide();
	            		flag = true;
	            	}
	        	} else if ($('.special-result-content').length > 0) {
                    if(cartQty > 40) {
                    	$form.closest('.mm-prod-details').find('.max-cart-qty').show();
                    	flag = false;
                    } else {
                    	$form.closest('.mm-prod-details').find('.max-cart-qty').hide();
                    	flag = true;
                    }
	        	} else {
	        		if(cartQty > 40) {
	            		$('.max-cart-qty').show();
	            		flag = false;
	            	} else {
	            		$('.max-cart-qty').hide();
	            		flag = true;
	            	}
	        	}
	        	if(flag) {
	        		checkProductATS($form);
	    		}
	        }
	    });
	}
}

var getSetCartAvailbility = function(e,quickOrder) {
	var setQty = 0;
	var dataForAjax;
	dataForAjax = {'pdtQty' : setQty};
	if($('input.specialproductset').val()==="true"){
		//var subPdtsCount = $('.product-set-list').find('.product-set-item').length;
		var mainSetQty = $('Select[name="Quantity"]:visible').val();
		//setQty = mainSetQty * subPdtsCount ;
		setQty = mainSetQty;
		var serialForm = $('.add-all-to-cart').closest('form').serialize();
		if(serialForm.indexOf("cartAction=update") > -1) {
			var setID = $('.product-set-addall').find('.productset-pid').text();
			dataForAjax = {'pdtQty' : setQty,'pid' : setID};
		} else {
			dataForAjax = {'pdtQty' : setQty};
		}
	} else {
		$('.product-set-item ').find('Select[name="Quantity"]').each(function(index,value){
			setQty += +$(this).val();
			dataForAjax = {'pdtQty' : setQty};
		});
	}
	if(quickOrder) {
		$('.product-content-quickorder').find('Select[name="Quantity"]').each(function(index,value){
			setQty += +$(this).val();
			dataForAjax = {'pdtQty' : setQty};
		});
	}
	ajax.getJson({
        url: util.ajaxUrl(Urls.getCartAvailability),
        data: dataForAjax,
        callback: function (response) {
        	var cartQty = response.error;
        	var flag = true;
        	if(cartQty > 40) {
        		$('.max-cart-qty-set').show();
        		flag = false;
        	} else {
        		$('.max-cart-qty-set').hide();
        		flag = true;
        	}
        	if(flag) {
    		   if($('input.specialproductset').val()==="true"){
    		    	addSpecialProductSetToCart(e);
    		    }else{
		    		var $productForms = $('#product-set-list').find('form').toArray();
		    		var $cqouuid = "";
    		    	if(quickOrder){
    		    		 $productForms = $('.hemmingmonograming').find('form').toArray();
    		    		 $cqouuid = $('.hemmingmonograming').find('input[name="editedCQOItemUUID"]');
    		    	}
    		    	Promise.all(_.map($productForms, addItemToCart))
    		        .then(function (responses) {
    		        	//on add all to bag if any product action is update then navigate to cart page
    		        	if( $cqouuid.length > 0 ){
    		        		var cqoUUID = $cqouuid.val();
    		        		if (cqoUUID.length > 0) {
    		        			window.location.href = Urls.cartShow;
    		        		}
    		        	}else{
    		        		dialog.close();
        		            // show the final response only, which would include all the other items
        		            minicart.show(responses[responses.length - 1]);
        		            cartOverlay.openCartOverlay(responses[responses.length-1],responses);
    		        	}
    		        });
    		    }
        	}
        }
    });
}

var updateMinicartQty = function(response){
	let newQuantity = $(response).find('.minicart-quantity').text();
	if(newQuantity > 0 && $('.ucp2-cart-icon').length){
		$('.ucp2-cart-icon').toggleClass('ucp2-cart-with-item-icon');
		$('.ucp2-cart-icon.ucp2-cart-with-item-icon').toggleClass('ucp2-cart-icon');
		$('.ucp2-cart-with-item-icon').append('<span class="minicart-quantity total-qty">'+newQuantity+'</span>');
		$('.shopping-bag-sm').attr({"data-overlay-on-hover": 'yes', "data-is-overlay": 'yes','data-overlayname' : "fly-overlay-bag"});
	}
	else if(newQuantity > 0 && $('.ucp2-cart-with-item-icon > span.minicart-quantity').length && $('.ucp2-cart-icon > span.minicart-quantity').text() !== newQuantity){
		$('.ucp2-cart-with-item-icon > span.minicart-quantity').text(newQuantity);
	}
	else if(newQuantity == 0 && $('.ucp2-cart-with-item-icon').length){
		$('.ucp2-cart-with-item-icon').toggleClass('ucp2-cart-icon');
		$('.ucp2-cart-with-item-icon.ucp2-cart-icon').toggleClass('ucp2-cart-with-item-icon');
	}
}

var checkProductATS = function ($form) {

	var maxAvailableQty = 0;
	var currentForm = $form;
	var quantity = currentForm.find('Select[name="Quantity"]').val();
	ajax.getJson({
        url: util.ajaxUrl(Urls.productVariantATS),
        data: $form.serialize(),
        callback: function (response) {
        	var atscount = response.error;
        	if(Number(response.error) < Number(quantity)){
        		if(Number(response.error) > 0) {
        			currentForm.find('.quantity-ats-message').removeClass("hide").addClass("padding-eight");
        		}else{
        			$('.quantity-ats-message').html('').html('Out of stock').removeClass("hide").addClass("padding-eight");
        		}
        		return false;
        	} else if(atscount == undefined) {
        		$('.quantity-ats-message').html('').html('Out of stock').removeClass("hide").addClass("padding-eight");
        		return false;
        	}
        	else {
        		$('.quantity-ats-message').addClass("hide").removeClass("padding-eight");
        	}
            addItemToCart($form).then(function (response) {
                var $uuid = $form.find('input[name="uuid"]');
                var $cqouuid = $form.find('input[name="editedCQOItemUUID"]');
                var $source = $form.find('input[name="source"]');
                if ($source.length > 0 && $source.val().length > 0 && $source.val() == 'wishlist') {
                    window.location.href = Urls.wishlistShow;
                }
                else if (($uuid.length > 0 && $uuid.val().length > 0) || ($cqouuid.length > 0 && $cqouuid.val().length > 0)) {
					//page.refresh();
					if(typeof($('#cartRedirect').val()) == 'undefined'){
						window.location.href = Urls.cartShow;
					} else{
						window.location.href = $('#cartRedirect').val();
					}                    
                } else {
                    // do not close quickview if adding individual item that is part of product set
                    // @TODO should notify the user some other way that the add action has completed successfully
                    if (!$(this).hasClass('sub-product-item')) {
						var isQuickviewButtonInFocus = $('a.quickview[data-returnfocus="true"]');
						
						dialog.close();
						if(isQuickviewButtonInFocus.length){
							isQuickviewButtonInFocus.attr('data-returnfocus','true');
						}
                    }
					minicart.show(response);
					updateMinicartQty(response);
                    cartOverlay.openCartOverlay(response);
                }
            });
        }
    });
}

/**
 * @description Handler to handle the add to cart event for hemming
 */
var validateHemming = function ($this) {
	var $hemmingmonograming = $this.closest('.hemmingmonograming');
	if ($('#wrapper').hasClass('quick-order-page')) {
		$hemmingmonograming = $this.closest('.pdpForm');
	}
	var $hemmingCheckBox = $hemmingmonograming.find('.product-hemming-checkbox');
	var flag = true;
	if ($hemmingCheckBox.length > 0) {
		if ($hemmingCheckBox.is(':checked')) {
			if ($hemmingmonograming.find('.hemming-drawer ul li.hemming-option.selected').length > 0){
				$hemmingmonograming.find('.hemming-error-msg').hide();
			} else {
				$hemmingmonograming.find('.hemming-error-msg').show();
				$hemmingmonograming.find('.hemming-error-msg').closest('.product-hemmable').addClass('error-msg');
				flag = false;
			}
		}
	}
	return flag;
};

var addSpecialProductSetToCart = function (e) {
	e.preventDefault();
	var childPids ="";
	var childQtys ="";
	var quantity = $('.specialProductset').find('.quantityinput :selected').val();
	$('.product-set-item ').find('input[name="pid"]').each(function(index,value){
		if(childPids !=''){
			childPids=childPids+','+$(this).val();
			childQtys = childQtys+','+quantity;
		}else{
			childPids=$(this).val();
			childQtys = quantity;
		}
	});
	$('input[name="childPids"]').val(childPids);
	$('input[name="childQtys"]').val(childQtys);

	var hemingJSON = [];
	var monogramingJSON = [];

	$('.product-set-item ').each(function(index,value){
		var hemingJSONChlilds = new Object();
		hemingJSONChlilds.pid=$(value).find('input[name="pid"]').val();
		hemingJSONChlilds.hemmingoption=$(value).find('input[name="hemmingoption"]').val();
		hemingJSONChlilds.dwoptHemming=$(value).find('input[name$="_hemming"]').first().val();
		hemingJSON.push(hemingJSONChlilds);

		var monogramingJSONChlilds = new Object();
		monogramingJSONChlilds.pid=$(value).find('input[name="pid"]').val();
		monogramingJSONChlilds.monogramFont = $(value).find('select[name="monogram-font"]').val();
		monogramingJSONChlilds.monogrammLocation = $(value).find('select[name="monogram-location"]').val();
		monogramingJSONChlilds.monogramColor = $(value).find('select[name="monogram-color"]').val();
		monogramingJSONChlilds.dwoptMonograming = $(value).find('input[name$="_monogramming"]').val();
		var monogramText = "";
		$(value).find('.monogramming-textfield').each(function(index,text) {
			if (monogramText != null) {
				monogramText = monogramText +'~-'+ $(this).val();
			} else {
				monogramText = $(this).val();
			}
		});
		monogramingJSONChlilds.monogramText = monogramText;
		monogramingJSON.push(monogramingJSONChlilds);
	});
	$('input[name="hemmingJson"]').val(JSON.stringify(hemingJSON));
	$('input[name="monogramingJson"]').val(JSON.stringify(monogramingJSON));

	var $form = $('.add-all-to-cart').closest('form');
	var maxAvailableQty = 0;
	ajax.getJson({
        url: util.ajaxUrl(Urls.specialProductSetATS),
        data: $form.serialize(),
        callback: function (response) {
        	var responseObj = JSON.parse(response.error);
        	if(Number(responseObj.maxAvailableATS) < Number(quantity)){
        		if(Number(responseObj.maxAvailableATS) > 0){
        			$('.product-set-main-button-error').html(Resources.ERROR_CARTQUANTITY+' '+responseObj.maxAvailableATS).show();
        		}else{
        			$('.product-set-main-button-error').html('Out of stock').show();
        		}
        		return false;
        	}
        	$('.product-set-main-button-error').html('');
        	addItemToCart($form).then(function (responses) {
                var $uuid = $form.find('input[name="uuid"]');
                var $source = $form.find('input[name="source"]');
                if ($source.length > 0 && $source.val().length > 0 && $source.val() == 'wishlist') {
                    window.location.href = Urls.wishlistShow;
                } else if ($uuid.length > 0 && $uuid.val().length > 0) {
                    //page.refresh();
                    window.location.href = Urls.cartShow;
                } else {
                    // do not close quickview if adding individual item that is part of product set
                    // @TODO should notify the user some other way that the add action has completed successfully
                    if (!$(this).hasClass('sub-product-item') && $('input.specialproductset').val() != "true") {
                        dialog.close();
                    }
                    //minicart.show(response);
                    // show the final response only, which would include all the other items
					minicart.show(responses);
					updateMinicartQty(responses);
                    cartOverlay.openCartOverlay(responses);
                }
            }.bind(this));
        }
    });
}

var checkMonogrammingHemming = function (e) {
	var status = "valid";
	$('.product-hemming-checkbox').each(function(index,value){
		if($(value).prop('checked') && $(value).closest('.product-hemmable').find('.hemming-option.selected').length==0) {
			$(value).closest('.product-hemmable').find('.hemming-error-msg').show();
			$(value).closest('.product-hemmable').addClass('error-msg');
			status = "invalid";
		}
	});
	$('.monogramming-enabled-class').each(function(index,value){
		if($(value).prop('checked') && $(value).closest('.form-row.product-monogramming').find('.monogram-font-class :selected').val()==='') {
			$(value).closest('.form-row.product-monogramming').find('.monogram-font-class :selected').text('').text(Resources.INVALID_FONT);
			$(value).closest('.form-row.product-monogramming').find('.monogram-font-class').addClass('mono-error');
			$(value).closest('.form-row.product-monogramming').addClass('error-msg');
			status = "invalid";
		}
		if($(value).prop('checked') && $(value).closest('.form-row.product-monogramming').find('.monogram-location-class :selected').val()==='') {
			$(value).closest('.form-row.product-monogramming').find('.monogram-location-class :selected').text('').text(Resources.INVALID_POSITION);
			$(value).closest('.form-row.product-monogramming').find('.monogram-location-class').addClass('mono-error');
			$(value).closest('.form-row.product-monogramming').addClass('error-msg');
			status = "invalid";
		}
		if($(value).prop('checked') && $(value).closest('.form-row.product-monogramming').find('.monogram-color-class :selected').val()==='') {
			$(value).closest('.form-row.product-monogramming').find('.monogram-color-class :selected').text('').text(Resources.INVALID_COLOR);
			$(value).closest('.form-row.product-monogramming').find('.monogram-color-class').addClass('mono-error');
			$(value).closest('.form-row.product-monogramming').addClass('error-msg');
			status = "invalid";
		}
		if($(value).prop('checked')){
			$(value).closest('.form-row.product-monogramming').find('.monogramming-textfield').each(function(index,newValue) {
				if($(newValue).val()==''){
					$(newValue).attr('placeholder',Resources.INVALID_TEXT).addClass('mono-error');
					status = "invalid";
				}
			});
		}
	});
	return status;
}

/**
 * @description Handler to handle the add all items to cart event
 */
var addAllToCart = function (e) {
	if(($('.add-all-to-cart').length && $('.add-all-to-cart').attr('aria-disabled') === "true") || ($('.add-all-to-cart-disabled').length && $('.add-all-to-cart-disabled').attr('aria-disabled') === "true")){
		return false;
	}
    e.preventDefault();
    $('.product-set-main-button-error').text('');
    $('input[name="addallevent"]').val("true");
    if($('.add-all-to-cart').length>0 || $('.add-all-to-cart-disabled').length>0){
    	var arr = [];
    	$('.variation-selection-error-msg>span').each(function( index,value){
    		if(arr.indexOf(value.className)==-1){
    			arr.push(value.className);
    		}
    	});
    	var missingAttr = "";
    	$.each(arr, function(index, value) {
    		if(missingAttr==''){
    			missingAttr = value;
    		}else if(index==arr.length-1){
    			missingAttr = missingAttr +" and "+value;
    		}else{
    			missingAttr = missingAttr +","+value;
    		}
    	});
    	$('.variation-selection-error-msg').show();
    	$('.variation-selection-error-msg').each(function(e){
    		$(this).closest('.attribute').find('.label').hide();
    	})
    	if(missingAttr != ''){
    		$('.product-set-main-button-error').append('Please select '+missingAttr).show();
    		return false;
    	}


    }
    if(checkMonogrammingHemming(e)== 'invalid'){
    	return false;
    }
    var quickOrder = false;
    getSetCartAvailbility(e,quickOrder);
};

var addAllToCartQuickOrder = function (e){
	if($('.add-all-to-cart-quick-order').length && $('.add-all-to-cart-quick-order').attr('aria-disabled') === "true"){
		return false;
	}
    e.preventDefault();
    $('input[name="addallevent"]').val("true");
    if(checkMonogrammingHemming(e)== 'invalid'){
    	return false;
    }

    var quickOrder = true;
    getSetCartAvailbility(e,quickOrder);
};
/**
 * @function
 * @description Binds the click event to a given target for the add-to-cart handling
 */
module.exports = function () {
    $('.add-to-cart-disabled').attr('title', $('.availability-msg').text());
    $('body').off('click', '.add-to-cart').on('click', '.add-to-cart', addToCart);
    $("body").on('click', '.add-all-to-cart', addAllToCart);
    $("body").on('click', '.add-all-to-cart-disabled', addAllToCart);
    $('.pdp-main').off('click' , '.add-all-to-cart-quick-order').on('click' , '.add-all-to-cart-quick-order', addAllToCartQuickOrder);

    var $specialsMain = $('.special-result-content');
    $specialsMain.on('click', '#mm-add-to-cart', addToCart);
    $('.product-add-to-cart.specialProductset .quantity #Quantity').change(function(e){
    	$('.spacial-Product-Set').val($(this).val());
	});
	
	// WCAG - add to bag button focus outline issue
	$('body').on("keydown",".quantityinput",function(e){	
		if(e.keyCode === 9){
			$(this).closest('.inventory').next('button').trigger('mouseenter');
		}
	});
    $('body').on("mouseenter keyup",".add-to-cart, .add-to-cart-disabled, .all-set-button, .add-all-to-cart-quick-order",function(e){
		e.preventDefault();
		var $curObj = $(this);
		if($curObj.hasClass("all-set-button")) {
			var $listOfSet = $curObj.closest(".product-col-2").find("div").filter(".product-set-item");
			$listOfSet.each(function(i){
				var $curSet = $(this),
					$swatchSize =$curSet.find(".swatches").not('.color'),
					$swatchColor =$curSet.find(".swatches.color"),
					sizeSelectedLength = $swatchSize.find("li.selectable.selected").length;
					colorSelectedLength = $swatchColor.find("li.selectable.selected").length;
				var $availablemsg = $(this).find('.availability-msg .not-available-msg').length;
				var $swatchTopsize= $curSet.find(".swatches.size").parents().find(".sps_top_size");
				var $swatchBottomsize=$curSet.find(".swatches.size").parents().find(".sps_bottom_size");
				var topSizeSelectedLength = $swatchTopsize.find("li.selectable.selected").length;
				var bottomSizeSelectedLength = $swatchBottomsize.find("li.selectable.selected").length;
				if($('#pdpMain').hasClass('sw-specialproductset')){
					if( colorSelectedLength && topSizeSelectedLength && bottomSizeSelectedLength){
						$curObj.attr("aria-disabled","false").removeClass('atb-disabled');
						return false;
					}else if( (colorSelectedLength == 0) && topSizeSelectedLength && bottomSizeSelectedLength ) {
							$curObj.html(Resources.SPS_TOP_COLOR).attr("aria-disabled","true").addClass('atb-disabled');
							return false;
					}else if(colorSelectedLength && (topSizeSelectedLength == 0) && bottomSizeSelectedLength){
							$curObj.html(Resources.SPS_TOP_SIZE).attr("aria-disabled","true").addClass('atb-disabled');
							return false;
					}else if(colorSelectedLength && topSizeSelectedLength && (bottomSizeSelectedLength == 0)){
							$curObj.html(Resources.SPS_BOTTOM_SIZE).attr("aria-disabled","true").addClass('atb-disabled');
							return false;
					}
					else if((colorSelectedLength == 0) && (topSizeSelectedLength == 0) && bottomSizeSelectedLength){
						$curObj.html(Resources.SPS_TOP_COLOR_SIZE).attr("aria-disabled","true").addClass('atb-disabled');
						return false;
				}
					else if((colorSelectedLength == 0) && topSizeSelectedLength && (bottomSizeSelectedLength == 0)){
						$curObj.html(Resources.SPS_TOP_COLOR_BOTTOM_SIZE).attr("aria-disabled","true").addClass('atb-disabled');
						return false;
				}
					else if(colorSelectedLength && (topSizeSelectedLength == 0) && (bottomSizeSelectedLength == 0)){
						$curObj.html(Resources.SPS_TOPBOTTOM_SIZE).attr("aria-disabled","true").addClass('atb-disabled');
						return false;
					}
					else if((colorSelectedLength == 0) && (topSizeSelectedLength == 0) && (bottomSizeSelectedLength == 0)){
							$curObj.html(Resources.SPS_TOPBOTTOM_COLOR_SIZE).attr("aria-disabled","true").addClass('atb-disabled');
							return false;
					}
					
				}else{
					if($swatchColor.length != sizeSelectedLength && $swatchSize.length != sizeSelectedLength) {
						$curObj.html(Resources.SELECT_COLOR_SIZE).attr("aria-disabled","true").addClass('atb-disabled');
						return false;
					}else if($swatchColor.length != sizeSelectedLength){
						$curObj.html(Resources.PLEASE_SELECT_COLOR).attr("aria-disabled","true").addClass('atb-disabled');
						return false;
					}else if($swatchSize.length != sizeSelectedLength){
						$curObj.html(Resources.PLEASE_SELECT_SIZE).attr("aria-disabled","true").addClass('atb-disabled');
						return false;
					}
					if($availablemsg > 0){
						$curObj.attr("aria-disabled","true").addClass('atb-disabled');
						return false;
					}
				}
			});
		} else if($(".catalog-quick-order").length > 0) {
			if($curObj.hasClass("add-all-to-cart-quick-order")) {
				var $listOfSet = $curObj.closest(".catalog-quick-order").find("div").filter(".product-quickorder-detail");
				$listOfSet.each(function(i){
					var $curSet = $(this),
						$swatchSize =$curSet.find(".swatches").not('.color'),
						$swatchColor =$curSet.find(".swatches.color"),
						sizeSelectedLength = $swatchSize.find("li.selectable.selected").length,
						colorSelectedLength = $swatchColor.find("li.selectable.selected").length;
					var $availablemsg = $(this).find('.availability-msg .not-available-msg').length;
					if( ($swatchSize.length > sizeSelectedLength || sizeSelectedLength == 0) || ($swatchColor.length > colorSelectedLength || colorSelectedLength == 0) ) {
						$(".add-all-to-cart-quick-order").find(".add-all-text").addClass("hide");
						$(".add-all-to-cart-quick-order").find(".select-size-text").removeClass("hide");
						$(".add-all-to-cart-quick-order").attr("aria-disabled","true").addClass('atb-disabled');
						return false;
					} else {
						$(".add-all-to-cart-quick-order").attr("aria-disabled","false");
						$(".add-all-to-cart-quick-order").removeClass('atb-disabled');
						$(".add-all-to-cart-quick-order").find(".add-all-text").removeClass("hide");
						$(".add-all-to-cart-quick-order").find(".select-size-text").addClass("hide");
					}
				});
			} else {
				var $curListOfSet = $curObj.closest(".product-quickorder-detail");
				$swatchSize = $curListOfSet.find(".swatches").not('.color'),				
				$swatchColor = $curListOfSet.find(".swatches.color").not('.size'),
				sizeSelectedLength = $swatchSize.find("li.selectable.selected").length;
				colorSelectedLength = $swatchColor.find("li.selectable.selected").length;
				var $availablemsg = $(this).find('.availability-msg .not-available-msg').length;
				$curListOfSet.find(".add-to-cart").removeClass("disabled").removeClass('atb-disabled');
				if($swatchSize.length != sizeSelectedLength && $swatchColor.length != colorSelectedLength) {
					$curListOfSet.find(".add-to-cart").addClass("disabled").html(Resources.SELECT_COLOR_SIZE).attr("aria-disabled","true").addClass('atb-disabled');
				}else if($swatchSize.length != sizeSelectedLength) {
					$curListOfSet.find(".add-to-cart").addClass("disabled").html(Resources.PLEASE_SELECT_SIZE).attr("aria-disabled","true").addClass('atb-disabled');
				}else if($swatchColor.length != colorSelectedLength) {
					$curListOfSet.find(".add-to-cart").addClass("disabled").html(Resources.PLEASE_SELECT_COLOR).attr("aria-disabled","true").addClass('atb-disabled');
				}
				if($availablemsg > 0){
					$curListOfSet.find(".add-to-cart").attr("aria-disabled","true").addClass('atb-disabled');
				}
				if($(".add-to-cart.disabled").length < 1 ) {
					$(".add-all-to-cart-quick-order").attr("aria-disabled","false").removeClass('atb-disabled');
					$(".add-all-to-cart-quick-order").find(".add-all-text").removeClass("hide");
					$(".add-all-to-cart-quick-order").find(".select-size-text").addClass("hide");
				}
			}

		} else {
			var $swatchSize = null;
			var $swatchColor = null;
			if($curObj.closest(".product-set-item").length > 0){
				//product set
				$swatchSize = $curObj.closest(".product-set-item").find(".swatches").not('.color');
				$swatchColor = $curObj.closest(".product-set-item").find(".swatches.color");
			}else{
				$swatchSize = $curObj.closest(".product-col-2").find(".swatches").not('.color');
				$swatchColor = $curObj.closest(".product-col-2").find(".swatches.color");
			}
			var sizeSelectedLength = $swatchSize.find("li.selectable.selected").length;
			var colorSelectedLength = $swatchColor.find("li.selectable.selected").length;
			if($swatchSize.length != sizeSelectedLength && $swatchColor.length != colorSelectedLength){
				$curObj.html(Resources.SELECT_COLOR_SIZE).attr("aria-disabled","true").addClass('atb-disabled');
			}else if($swatchSize.length != sizeSelectedLength ) {
				$curObj.html(Resources.PLEASE_SELECT_SIZE).attr("aria-disabled","true").addClass('atb-disabled');
			}else if($swatchColor.length != colorSelectedLength ) {
				$curObj.html(Resources.PLEASE_SELECT_COLOR).attr("aria-disabled","true").addClass('atb-disabled');
			}
		}
	});
};
